module.exports = __webpack_public_path__ + "media/day/389-1faeb26e.svg";